<script lang="ts">
  import { push } from "svelte-spa-router";
  import { setup, ApiError } from "../lib/api";
  import { setUser } from "../lib/stores/auth";

  let username = "";
  let password = "";
  let displayName = "";
  let fieldError = "";
  let errorMsg = "";
  let submitting = false;

  async function handleSubmit() {
    fieldError = "";
    errorMsg = "";
    if (!username) { fieldError = "Username is required"; return; }
    if (!password) { fieldError = "Password is required"; return; }
    submitting = true;
    try {
      const user = await setup(username, password, displayName || undefined);
      setUser(user);
      push("/map");
    } catch (e) {
      if (e instanceof ApiError && e.status === 410) {
        errorMsg = "Setup already complete — please log in.";
      } else {
        errorMsg = "Setup failed. Please try again.";
      }
    } finally {
      submitting = false;
    }
  }
</script>

<main>
  <h1>First-Run Setup</h1>
  <p>Create the initial admin account.</p>
  <form on:submit|preventDefault={handleSubmit}>
    {#if fieldError}
      <p class="field-error">{fieldError}</p>
    {/if}
    {#if errorMsg}
      <p role="alert" class="error">{errorMsg}</p>
    {/if}
    <div>
      <label for="username">Username</label>
      <input id="username" type="text" bind:value={username} autocomplete="username" />
    </div>
    <div>
      <label for="password">Password</label>
      <input id="password" type="password" bind:value={password} autocomplete="new-password" />
    </div>
    <div>
      <label for="display-name">Display Name</label>
      <input id="display-name" type="text" bind:value={displayName} />
    </div>
    <button type="submit" disabled={submitting}>Create Admin</button>
  </form>
</main>
